<template>
<div class="text-center">
    <template v-if="order">
        <span class="sr-only"> {{ $t('message.merci') }}</span>
                  <b-row>
            <div class="col-12">
              <div class="timeline-box h-100">
                <div class="box-title">
                  <i class="fa fa-list" aria-hidden="true"></i>
                  {{ $t('message.detailsFacture') }}
                </div>
                <div class="box-content">
                  <div class="box-item column-display-style column-display-style-without-mb">
                    <div class="row">
                      <div class="col-6 text-right">
                        <p><strong>{{ $t('message.nomSouscripteur') }}</strong></p>
                      </div>
                      <div class="col-6 text-left">
                        <p>{{ order.souscripteur.user.nom }}</p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-6 text-right">
                        <p><strong>{{ $t('message.nomPatient') }}</strong></p>
                      </div>
                      <div class="col-6 text-left">
                        <p>{{ order.patients.user.nom }}</p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-6 text-right">
                        <p><strong>{{ $t('message.dateFacturation') }}</strong></p>
                      </div>
                      <div class="col-6 text-left">
                        <p>{{ formattedDate(order.date_facturation) }}</p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-6 text-right">
                        <p><strong>{{ $t('message.amount') }}</strong></p>
                      </div>
                      <div class="col-6 text-left">
                        <p>{{ order.amount }} FCFA</p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-6 text-right">
                        <p><strong>{{ $t('message.status') }}</strong></p>
                      </div>
                      <div class="col-6 text-left">
                        <p>{{ getStatut(order.statut) }}</p>
                      </div>
                    </div>
                    <div class="row" v-if="order.statut == 'PAYE'">
                      <div class="col-6 text-right">
                        <p><strong>{{ $tc('message.motifPayment',2) }}</strong></p>
                      </div>
                      <div class="col-6 text-left">
                        <p>{{ order.motif }}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="box-footer">
                  {{onShowBillClick(order.uuid)}}
                 Lien de paiement: <a :href="'/payment-prestation/'+order.uuid" target="_blank">{{ lien+order.uuid }}</a>
                </div>
              </div>
            </div>
          </b-row>
    </template>
</div>
</template>

<script>
import {mapGetters} from "vuex";
    import Swal from 'sweetalert2';
    import moment from 'moment';
export default {
    name: 'Show',
    props: ["baseURL"],
    computed: {
      ...mapGetters(["paymentPrestation",'hasAdminRole',
                'hasGestionnaireRole','isComptable']),
      can: function () {
          return this.hasAdminRole || this.hasGestionnaireRole || this.isComptable;
      },

      order:function () {
         return this.paymentPrestation;
      }
    },
    data() {
        return {
            updated: false,
            token: null,
            mOrder: this.paymentPrestation,
            sessionId: null,
            lien: window.location.origin+"/payment-prestation/"
        }
    },
    methods: {
         onShowBillClick(id) {
               // this.$router.push({ name: 'show-payment', params: { id: slug } });
              Swal.fire({
                  title: 'Lien de paiment !',
                  icon: 'info',
                  html: `Lien de paiement de la prestation</b>, <a href="/payment-prestation/${id}" target="_blank">${window.location.origin}/payment-prestation/${id}</a> `
              })
         },
        getStatut(item){
          if ( item == 'PAYE'  ) return 'Facture payée';
          else return item;
        },
        formattedDate(date) {
           return moment(date).format('DD-MM-YYYY');
        },
        getPaymentStatut() {
                let args = {
                   id: this.$route.params.id
                };

                this.$store.dispatch('getPaymentPrestation', { args : args });
            },
    },
    mounted() {
        //this.saveOrder();
        this.getPaymentStatut();
    }
}
</script>
